import { useEffect } from "react";
import useRouteName from "./useRouteName.js";
import useEvents from "./useEvents.js";
const useHeaderRouteChange = () => {
    const routeName = useRouteName();
    const { squeak, jsError } = useEvents();
    useEffect(() => {
        try {
            if (window.__webShellUpdateRoute) {
                window.__webShellUpdateRoute(routeName);
            }
            else {
                squeak("web-shell: route update interface not found");
            }
        }
        catch (e) {
            jsError(e);
        }
    }, [routeName, squeak, jsError]);
};
export default useHeaderRouteChange;
